<template>
  <FormWrapper type="forgot">
    <template slot="head" v-if="!isCompleted">
      <h3 class="kt-login__title">Forgotten Password?</h3>
      <div class="kt-login__desc" v-if="!isCompleted">Enter your email to reset your password:</div>
    </template>

    <template slot="head" v-if="isCompleted">
      <h3 class="kt-login__title">{{ message.text }}</h3>
    </template>

    <div
      class="alert fade show"
      :class="messageObj"
      v-if="message.text && !isCompleted">
      <div class="alert-icon text-white">
        <BaseIcon type="fas" icon="times" size="2x" v-if="this.message.class === 'error'" />
        <BaseIcon type="fas" icon="exclamation-triangle" size="2x"  v-if="this.message.class === 'warning'" />
        <BaseIcon type="fas" icon="check" size="2x"  v-if="this.message.class === 'success'" />
      </div>
      <div class="alert-text text-white">{{ message.text }}</div>
      <div class="alert-close">
        <button type="button" class="close text-white" @click="closeAlert">
          <span aria-hidden="true"><BaseIcon type="fas" icon="times" size="sm" /></span>
        </button>
      </div>
    </div>

    <form class="kt-form" @submit="sendPasswordRecovery" v-if="!isCompleted">
      <div class="form-group">
        <input
          type="email"
          class="form-control"
          placeholder="Email"
          autocomplete="off"
          :disabled="isLoading || isCompleted"
          :required="true"
          v-model="email">
      </div>
      <div class="kt-login__actions">
        <button
          type="submit"
          class="btn btn-primary btn-wide"
          :disabled="isLoading || isCompleted">Reset my password</button>
        <button
          type="button"
          class="btn btn-wide btn-outline-hover-brand"
          :disabled="isLoading"
          @click="redirect">Cancel</button>
      </div>
    </form>
  </FormWrapper>
</template>

<script>
import FormWrapper from '@/components/login/FormWrapper.vue'
import NProgress from 'nprogress'

export default {
  name: 'FormPasswordRecovery',
  components: {
    FormWrapper
  },
  data () {
    return {
      isLoading: false,
      message: { text: '', class: '' },
      email: '',
      hash: '',
      isCompleted: false
    }
  },
  computed: {
    messageObj () {
      return {
        'show': this.message.text,
        'alert-danger': this.message.class === 'error',
        'alert-warning': this.message.class === 'warning',
        'alert-success': this.message.class === 'success'
      }
    }
  },
  methods: {
    sendPasswordRecovery (e) {
      e.preventDefault()
      NProgress.start()
      this.isLoading = true
      // Getting a new hash ========================================
      this.$store
        .dispatch('auth/recoveryPassword')
        .then(response => {
          const hash = response.data.hash
          const email = this.email
          const payload = { email, hash }
          // Sending reset password =================================
          this.$store
            .dispatch('auth/resetPassword', payload)
            .then(response => {
              const text = response.data.message
              const status = response.data.status
              if (status) {
                this.isLoading = false
                this.isCompleted = true
                this.message = { text, class: 'success' }
                this.email = ''
              } else {
                this.isLoading = false
                this.message = { text, class: 'warning' }
              }
              NProgress.done()
            })
            .catch((error) => {
              const text = error.response.data.message
              this.isLoading = false
              this.isCompleted = false
              this.message = { text, class: 'error' }
              NProgress.done()
              console.log(error)
            })
          NProgress.done()
        })
        .catch((error) => {
          const text = error.response.data.message
          this.isLoading = false
          this.isCompleted = false
          this.message = { text, class: 'error' }
          NProgress.done()
          console.log(error)
        })
    },
    redirect () {
      this.$router.replace({ name: 'login' })
    },
    closeAlert () {
      this.message = ''
    }
  }
}
</script>
